module.exports = __webpack_public_path__ + "media/images/area/feature/tohoku/related/ko/1-63ccd3acf54e17ff85bdf5dd1c30749b.jpg";